import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "../../CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "../../CommonTocComponent/TocHeader/SingleHeadingText";
import Validity from "./Validity";
import { EMutualFundFlow } from "../MutualFund";
import { validityRadioEnum } from "../MutualFundConstant";
const CustomValidityData = (props) => {
    const device = DeviceContext();
    const [validity, setValidity] = React.useState({
        presetValidity: validityRadioEnum.UNTIL_CANCELLED,
        customValidity: "",
    });
    const HandleApplyBtn = () => {
        props.setPurchaseFormData((pData) => {
            return Object.assign(Object.assign({}, pData), { sipValidationPreset: validity.presetValidity, sipValidationCustom: validity.customValidity });
        });
        props.setShow(EMutualFundFlow.PURCHASE);
    };
    React.useEffect(() => {
        if (props.purchaseFormData) {
            setValidity({
                presetValidity: props.purchaseFormData.sipValidationPreset,
                customValidity: props.purchaseFormData.sipValidationCustom,
            });
        }
    }, [props.purchaseFormData]);
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Validity", closeFunction: () => {
                    props.setShow();
                } }) }),
        React.createElement("div", { className: "outer-body-section " },
            React.createElement(Validity, { validity: validity, setValidity: setValidity })),
        React.createElement("div", { className: "bottom-contents pe-3 ps-3  pb-2" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => HandleApplyBtn() })))) : (React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Validity")), bodyComp: React.createElement(React.Fragment, null,
            React.createElement("div", { className: "outer-body-section overflow-scroll-300 " },
                React.createElement(Validity, { validity: validity, setValidity: setValidity })),
            React.createElement("div", { className: "bottom-contents pe-3 ps-3 pb-3 pt-3 bg-white" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => HandleApplyBtn() }))) }))));
};
export default CustomValidityData;
